<ng-progress [spinner]="false" ngProgressHttp inert></ng-progress>
<router-outlet></router-outlet>
@defer (when chatSidebar.isOpen()) {
  @if (chatSidebar.isOpen()) {
    <div class="chat-sidebar-overlay" (click)="chatSidebar.close()"></div>
    <aside class="chat-sidebar-panel">
      <app-chat-sidebar (closeSidebar)="chatSidebar.close()"></app-chat-sidebar>
    </aside>
  }
} @error {
  <aside class="chat-sidebar-panel">
    <app-load-failed feature="chat-sidebar" />
  </aside>
}
